export const SetCoordinatesConstants = {
    GET_COORDINATES: 'GET_COORDINATES',
    SET_COORDINATES: 'SET_COORDINATES'
};